import { Outlet, createFileRoute, redirect, Link } from "@tanstack/react-router";

import { Deflow } from "@/clients/deflow";
import {
  hydrateDeflowSession,
  isAuthenticatedFromStore,
} from "@/lib/browser-auth";
import { MainNav } from "@/components/plugin-shared/main-nav";
import useDeflowSessionStore from "@/stores/useDeflowSessionStore";
import type { APIAccount } from "deflow-models";

export const Route = createFileRoute("/_authenticated")({
  beforeLoad: async ({ location }) => {
    await hydrateDeflowSession();
    if (!isAuthenticatedFromStore()) {
      throw redirect({
        to: "/sign-in",
      });
    }

    const tokens = useDeflowSessionStore.getState().tokens;
    if (!tokens?.accessToken) {
      throw redirect({ to: "/sign-in" });
    }

    const account = (await Deflow.get({
      url: "/v1/account",
      token: tokens.accessToken,
    })) as APIAccount;

    const onPendingPage = location.pathname.endsWith("/pending-approval");

    if (account.accountStatus === "pending" && !onPendingPage) {
      throw redirect({ to: "/pending-approval" });
    }

    if (account.accountStatus !== "pending" && onPendingPage) {
      throw redirect({ to: "/dashboard" });
    }
  },
  component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <header className="flex h-14 items-center border-b px-6 gap-6">
        <img src="/deflow.png" alt="Deflow" width={100} height={22} />
        <MainNav />
        <Link
          to="/sign-out"
          className="ml-auto text-sm text-muted-foreground hover:text-foreground"
        >
          Sign out
        </Link>
      </header>
      <Outlet />
    </div>
  );
}
